import { api } from '@forbiz/web-kit'
import type { FuneralHallResolveResponse, FuneralHallResponse, FuneralHallSearchResponse } from '@forbiz/contracts'

/**
 * 장례식장 (BIZ-90). 주문서가 장소명을 명부와 연결해 제휴(디지털 화환)·화환 취급을 판정한다.
 * 연결은 서버가 정규화 정확 일치로 하고, 못 찾으면 hall=null — 자유 입력은 그대로 유지.
 */
export const funeralHallApi = {
  search: (q: string) => api.get<FuneralHallSearchResponse>(`/api/funeral-halls?${new URLSearchParams({ q })}`),
  /** 단건 + 빈소 목록. 주문서가 선택·연결된 식장의 주소·빈소를 채우는 데 쓴다. */
  get: (id: number) => api.get<FuneralHallResponse>(`/api/funeral-halls/${id}`),
  resolve: (name: string, address?: string) =>
    api.get<FuneralHallResolveResponse>(
      `/api/funeral-halls/resolve?${new URLSearchParams({ name, ...(address ? { address } : {}) })}`,
    ),
}
